// extracted by mini-css-extract-plugin
export default {"wrapper":"dragAndDrop_wrapper__GVeY2","item":"dragAndDrop_item__LHww2","itemActive":"dragAndDrop_itemActive__XilxF"};